/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const storePreferentialOriginDocumentForLinkingDelivery = /* GraphQL */ `mutation StorePreferentialOriginDocumentForLinkingDelivery(
  $inputs: [LinkDeliveryPreferentialOriginDocumentInput]
) {
  storePreferentialOriginDocumentForLinkingDelivery(inputs: $inputs)
}
` as GeneratedMutation<
  APITypes.StorePreferentialOriginDocumentForLinkingDeliveryMutationVariables,
  APITypes.StorePreferentialOriginDocumentForLinkingDeliveryMutation
>;
